import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight } from "@phosphor-icons/react";
import Seo from "@/components/Seo";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.must_change_password ? "/change-password" : next);
    }
    catch (e) {
      const d = e.response?.data?.detail;
      setError(typeof d === "string" ? d : "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[88vh] flex items-center" data-testid="login-page">
      <Seo title="Sign In" path="/login" noindex />
      <div className="container-x grid grid-cols-12 gap-8 items-center">
        <div className="hidden lg:block lg:col-span-6">
          <div className="aspect-square overflow-hidden border border-white/10">
            <img src="/media/range-coaching.jpg" alt="Live-fire coaching at the SEP range" className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="col-span-12 lg:col-span-5 lg:col-start-8">
          <div className="overline mb-4">// AUTHENTICATE</div>
          <h1 className="font-heading text-5xl tracking-tighter mb-3">Welcome back, operator.</h1>
          <p className="text-neutral-400 mb-8">Sign in to access your training dashboard.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <div className="label-mono mb-2">Email</div>
              <input data-testid="login-email" className="field" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
            </div>
            <div>
              <div className="label-mono mb-2">Password</div>
              <input data-testid="login-password" className="field" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
            </div>
            {error && <div data-testid="login-error" className="font-mono text-sm text-red-400">{error}</div>}
            <button disabled={loading} type="submit" data-testid="login-submit" className="btn-primary w-full justify-center">
              {loading ? "Authenticating..." : "Sign In"} <ArrowRight size={14} />
            </button>
          </form>
          <div className="mt-6 font-mono text-xs text-neutral-500">
            No account? <Link to="/register" className="text-[#FFD300]" data-testid="go-register">Create one →</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
